var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.parentStyle),on:{"click":_vm.click}},[(_vm.isIOS)?_c('CanvasVideo',{ref:"vid",style:(_vm.style),attrs:{"height":"800","width":"800","src":_vm.src,"loop":true}}):_c('video',{ref:"vid",style:(_vm.style),attrs:{"height":"800","width":"800","src":_vm.src,"poster":_vm.poster,"loop":""}}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-291afc4a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Settings/Video.vue
// module id = null
// module chunks = 